import PropTypes from 'prop-types';
import React from 'react';

import { Flex } from '../../grid';
import { P, Label } from '../../typography/new';

const ButtonContent = ({ children, leftContent, leftText, rightText, disabled, textVariant, labelProps }) => {
  return (
    <Flex as="span" justifyContent="space-between" width="100%" alignItems="center">
      {leftContent ||
        (leftText && (
          <Flex as="span" className="button-icon" flex={1}>
            {leftText && (
              <Label display="flex" alignItems="center" disabled={disabled}>
                {leftText}
              </Label>
            )}
            {leftContent}
          </Flex>
        ))}
      <Label
        as="span"
        display="flex"
        alignItems="center"
        justifyContent="center"
        width="100%"
        variant={textVariant}
        {...labelProps}
      >
        {children}
      </Label>
      {rightText && (
        <Flex as="span" flex={1} justifyContent="flex-end">
          <P as="span" variant="standard" display="flex" alignItems="center" disabled={disabled}>
            {rightText}
          </P>
        </Flex>
      )}
    </Flex>
  );
};

ButtonContent.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  leftContent: PropTypes.node,
  leftText: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  rightText: PropTypes.string,
  labelProps: PropTypes.any,
  textVariant: PropTypes.string,
};

ButtonContent.defaultProps = {
  leftContent: null,
  leftText: null,
  rightText: null,
  disabled: false,
  labelProps: null,
  textVariant: null,
};

export { ButtonContent };
